var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.relatedModuleLogoAvailable)?_c('RelatedLogo'):_c('f7-icon',{class:_vm.$style.icon,attrs:{"icon":"fal fa-calendar-day","size":"60"}})}
var staticRenderFns = []

export { render, staticRenderFns }